import React from "react";

/**
 * Red banner used at the top of auth forms to surface server-side errors
 * that aren't tied to a specific field (e.g. "Invalid credentials",
 * network failure). Field-level validation errors belong next to the
 * field via AuthFormField's `error` prop instead.
 */
const AuthErrorBanner: React.FC<{ message: string | null }> = ({ message }) => {
  if (!message) return null;
  return (
    <div
      className="p-4 text-sm text-red-800 border border-red-200 rounded-lg bg-red-50"
      role="alert"
    >
      {message}
    </div>
  );
};

export default AuthErrorBanner;
